module.exports = __webpack_public_path__ + "static/media/AgendaL.ded1c746.jpg";